import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "col q-pl-md q-pt-md" }

import { useDialogPluginComponent } from "quasar"
import SfxBtn from "src/components/button/SfxBtn.vue"
import SfxBtnOutline from "src/components/button/SfxBtnOutline.vue"
import SfxCardAttachment from "src/components/card/SfxCardAttachment.vue"
import SfxInput from "src/components/input/SfxInput.vue"
import { showNotImplementedNotification } from "src/util/functions/notifications"
import { Attachment } from "src/util/types/dataModels/attachment"
import { computed, PropType, ref } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits

const checkboxSize = "112px"


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogAttachmentDetails',
  props: {
  entity: {
    type: String,
    required: true,
  },

  attachment: {
    type: Object as PropType<Attachment>,
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { t } = useI18n()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const title = t("sfxDialogAttachmentDetails.title")
const labelDescription = t("sfxDialogAttachmentDetails.label_description")
const checkBoxAllowDownloads = t("sfxDialogAttachmentDetails.check_box_allow_downloads")
const btnCancel = t("sfxButtons.btn_cancel")
const btnSave = t("sfxButtons.btn_save")

const originalDescription = props.attachment?.description || ""
const description = ref<string>(props.attachment?.description || "")
const allowDownloads = ref<boolean>(true)

const saveDisabled = computed(
  () => description.value.length === 0 || originalDescription === description.value
)

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_checkbox = _resolveComponent("q-checkbox")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "text-h3" }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(title)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pb-lg" }, {
            default: _withCtx(() => [
              _createVNode(SfxInput, {
                modelValue: description.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((description).value = $event)),
                label: _unref(labelDescription),
                required: "",
                "error-message": _ctx.$t('sfxDialogConnectVueDevtools.invalid_input'),
                "hide-bottom-space": ""
              }, null, 8, ["modelValue", "label", "error-message"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "row q-pb-lg" }, {
            default: _withCtx(() => [
              _createVNode(_component_q_checkbox, {
                modelValue: allowDownloads.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((allowDownloads).value = $event)),
                "keep-color": "",
                dense: "",
                color: "navy-base",
                size: checkboxSize,
                class: "sfx-checkbox",
                disable: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_unref(showNotImplementedNotification)()))
              }, null, 8, ["modelValue"]),
              _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(checkBoxAllowDownloads)), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "q-pb-sm" }, {
            default: _withCtx(() => [
              _createVNode(SfxCardAttachment, {
                attachment: props.attachment,
                entity: props.entity
              }, null, 8, ["attachment", "entity"])
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, { class: "q-pa-md" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnOutline, {
                label: _unref(btnCancel),
                class: "col",
                onClick: _unref(onDialogCancel)
              }, null, 8, ["label", "onClick"]),
              _createVNode(SfxBtn, {
                label: _unref(btnSave),
                class: "col",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_unref(onDialogOK)(description.value))),
                disable: saveDisabled.value
              }, null, 8, ["label", "disable"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})